<template>
  <div class="prize-details-container">
		<div class="prize-info">
			<img class="product-img" src="https://voopoo-test.oss-cn-shenzhen.aliyuncs.com/iccpp-ars/status/1s23dfsd4f56sdf46s1213.jpg" alt="">
			<div class="right-info">
				<span class="code-info">充值码：Y2454534LJslk9Sn</span>
				<span class="receive-time">领取时间：2025.12.01 23:59:59</span>
				<span class="expire-time">使用截止时间：2025.12.30 23:59:59</span>
			</div>
		</div>
		<div class="use-info">
			<div class="info-title">奖品领取与使用说明</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxx</div>
			<div class="item-info">xxxxxxxxxxxxxxxxxxxxxxx</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'PrizeDetail',
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.prize-details-container {
  height: 100vh;
  background-color: #f2f2f2;
	.prize-info {
		display: flex;
		align-items: center;
		background-color: #fff;
		padding: 16px 10px;
		font-size: 12px;
		.product-img {
			width: 60px;
			height: 60px;
			margin-right: 10px;
		}
		.right-info {
			display: flex;
			flex-direction: column;
			.code-info {
				font-weight: bold;
				font-size: 14px;
			}
			.receive-time {
				margin: 6px 0;
			}
		}
	}
	.use-info {
		padding: 16px 10px;
		.info-title {
			margin-bottom: 10px;
		}
		.item-info {
			margin-bottom: 5px;
		}
	}
}
</style>
